module.exports = __webpack_public_path__ + "img/library-enddate-icon.65edb92c.svg";